import { Navigate, useParams } from 'react-router'
import { Spinner } from 'tailwind-v4/components/spinner'
import { useHardwareTier } from '@/hooks/use-hardware-tier'

/**
 * Redirects a retired top-level Wi-Fi route (Activity, Topology, …) into the
 * venue's hardware group, choosing the destination by hardware tier: SnapGuard
 * venues land in the SnapGuard group, everyone else in the Hardware group.
 * Waits for the tier to resolve so it never bounces to the wrong place.
 */
export function RedirectByTier({
  snapTo,
  hardwareTo,
}: {
  /** Path under `wi-fi/` for SnapGuard venues, e.g. `snap-guard/health`. */
  snapTo: string
  /** Path under `wi-fi/` for all other venues, e.g. `hardware`. */
  hardwareTo: string
}) {
  const { serial = '', org_id: orgId = '' } = useParams<{
    serial: string
    org_id: string
  }>()
  const { tier, isLoading } = useHardwareTier(serial)

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spinner />
      </div>
    )
  }

  const dest = tier === 'snapguard' ? snapTo : hardwareTo
  return <Navigate to={`/${orgId}/venues/${serial}/wi-fi/${dest}`} replace />
}

export default RedirectByTier
